module.exports = __webpack_public_path__ + "static/media/tr.020529a9.svg";